module.exports = __webpack_public_path__ + "img/vote_bg_r.68e59859.png";